import React, { useState } from 'react';
import '../styles/NewsletterFooter.css';
import { Link } from 'react-router-dom';
const NewsletterFooter = () => {
  const closeMenu = () => setMenuOpen(false);
  const [, setMenuOpen] = useState(false);
  return (
    <footer className="footer">
      {/* Top Grid */}
      <div className="footer-grid">
        {/* Left: Logo & Newsletter */}


        {/* Right: Quick Links & Courses */}
        <div className="footer-links-section">
          <div>
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/" onClick={closeMenu}  >Home</Link></li>
              <li><Link to="/#HomeAbout" onClick={closeMenu}>About us</Link></li>
              <li><Link to="/#HomeCourses" onClick={closeMenu}>Courses</Link></li>
              <li><Link to="/#HomeSampleQuestionnaire" onClick={closeMenu} >Sample Questionnaire</Link></li>
              <li><Link to="/#HomeTestimonials" onClick={closeMenu}>Testimonials</Link></li>
              <li><Link to="/contact-us" onClick={closeMenu}>Contact Us</Link></li>

            </ul>
          </div>
          <div>
            <h4>Courses</h4>
            <ul>
              <li>Prometric</li>
              <li>DHA – UAE</li>
              <li>HAAD – Abu Dhabi</li>
              <li>NCLEX – RN – USA</li>

            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Info */}
      <div className="footer-contact">
        {/* Phone / WhatsApp */}
        <div>
          <strong>
            ▶
            <a
              href="https://wa.me/918891263199"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit", paddingLeft:"6px" ,paddingRight:"2px"  }}
            > 
              WhatsApp 
            </a>
            / 
            <a
              href="tel:+918891263199"
              style={{ textDecoration: "none", color: "inherit" , paddingLeft:"2px" ,paddingRight:"2px" }}
            >
              Phone
            </a>
          </strong>
          <br />
          <a href="tel:+918891263199" style={{ textDecoration: "none", color: "inherit",  }}>
            +91 8891263199
          </a>
        </div>

        {/* Email */}
        <a
          href="mailto:info@davidacademy.in"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div>
            <strong>▶ Email</strong><br />
            info@davidacademy.in
          </div>
        </a>

        {/* Working Hours */}
        <div>
          <strong>▶ Working Hours</strong><br />
          Mon – Sat 9.00 AM – 6.00 PM, Sunday : Closed
        </div>
      </div>


      <hr />

      {/* Copyright */}
      <div className="footer-bottom">
        <p>© 2025 David's Academy. All rights reserved. | Designed by Lunar Enterprises</p>
      </div>
    </footer>
  );
};

export default NewsletterFooter;
